export default "__VITE_ASSET__Dxk$aAZE__"